module.exports = "/next-static/_next/static/images/noNativeGuestSupport-355241a8e03f223fecd1980ef9f73b8d.png";